import "./art_piece_details.scss";

import * as types from "@root/types";
import cx from "classnames";
import React, { FC } from "react";

interface ArtPieceInfoProps {
  label: string;
  value?: string | number | null;
  classes: string;
}

const ArtPieceInfo: FC<ArtPieceInfoProps> = ({ label, value, classes }) => {
  if (!value) {
    return null;
  }

  return (
    <div className={cx("art-piece-info--wrapper", classes)}>
      <span className="art-piece-info--label">{label}</span>
      <span className="art-piece-info--value">{value}</span>
    </div>
  );
};
interface ArtPieceDetailsProps {
  artPiece: types.ArtPiece;
}

const ArtPieceDetails: FC<ArtPieceDetailsProps> = ({ artPiece }) => {
  return (
    <>
      <div className="art-piece-details--left">
        <ArtPieceInfo
          label="Title: "
          value={artPiece.title}
          classes="art-piece-details--title"
        />
        <ArtPieceInfo
          label="Price:"
          value={artPiece.displayPrice}
          classes="art-piece-details--price"
        />
      </div>
      <div className="art-piece-details--right">
        <ArtPieceInfo
          label="Dimensions:"
          value={artPiece.dimensions}
          classes="art-piece-details--dimensions"
        />
        <ArtPieceInfo
          label="Medium:"
          value={artPiece.medium}
          classes="art-piece-details--medium"
        />
        <ArtPieceInfo
          label="Year:"
          value={artPiece.year}
          classes="art-piece-details--year"
        />
      </div>
    </>
  );
};

export { ArtPieceDetails, ArtPieceDetailsProps };
